import React from 'react';
import ResourceMapperActiveIcon from 'assets/resource_mapper_active.svg';
import ResourceMapperActiveNotifIcon from 'assets/resource_mapper_active_notif.svg';
import ResourceMapperIcon from 'assets/resource_mapper.svg';
import ResourceMapperNotifIcon from 'assets/resource_mapper_notif.svg';
import { APIState } from '../../models/APIState';

interface ResourceMapperMenuIconProps {
  className?: string;
  selected: boolean;
  unmappedResourcesStatus: APIState;
}

function getIconProperties({ unmappedResourcesStatus, selected }: ResourceMapperMenuIconProps) {
  let imgSrc;
  let imgAlt;

  switch (unmappedResourcesStatus) {
    case APIState.SUCCESS:
      imgSrc = selected ? ResourceMapperActiveNotifIcon : ResourceMapperNotifIcon;
      imgAlt = 'resource mapper icon';
      break;
    case APIState.EMPTY:
    case APIState.LOADING:
    case APIState.FAIL:
    default:
      imgSrc = selected ? ResourceMapperActiveIcon : ResourceMapperIcon;
      imgAlt = 'resource mapper empty icon';
  }
  return { imgSrc, imgAlt };
}

const ResourceMapperMenuIcon = ({
  unmappedResourcesStatus,
  selected,
  className,
}: ResourceMapperMenuIconProps) => {
  let { imgSrc, imgAlt } = getIconProperties({ unmappedResourcesStatus, selected });

  return <img className={className} src={imgSrc} alt={imgAlt} />;
};
export default ResourceMapperMenuIcon;
